import { render, staticRenderFns } from "./workshopInfo.vue?vue&type=template&id=5950fd7f&scoped=true"
import script from "./workshopInfo.vue?vue&type=script&lang=js"
export * from "./workshopInfo.vue?vue&type=script&lang=js"
import style0 from "./workshopInfo.vue?vue&type=style&index=0&id=5950fd7f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5950fd7f",
  null
  
)

export default component.exports